import React, { useState } from 'react';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ExpandMore } from '@/components/expand-more/expand-more';

const SignatureRequirements = () => {
	const [expandedDPI, setExpandedDPI] = useState(true);
	const [expandedGA, setExpandedGA] = useState(true);
	const [expanded3, setExpanded3] = useState(true);
	const [expanded4, setExpanded4] = useState(true);

	return (
		<>
			<DialogHeader className="moveRight moveDown">
				<DialogTitle>Firma electrónica</DialogTitle>
			</DialogHeader>

			<ExpandMore
				title="Solicitar firma"
				body={`
								El proceso de solicitar firma requiere un
								documento de identificación válido y un teléfono
								con cámara y la aplicación Google o Microsoft
								Authenticator. El app servirá para verificar tu
								identidad al momento de firmar documentos y
								realizar otras acciones que requieren de
								seguridad adicional.
`}
				isCollapsed={!expandedDPI}
				toggleExpand={() => setExpandedDPI(!expandedDPI)}
			/>
			<ExpandMore
				title="Suspender firma"
				body={`
								Para el proceso de suspender firma, se requiere
								el codigo de Google o Microsoft Authenticator
								para verificar la identidad del usuario. El
								proceso de suspensión de firma puede aplicarse y
								revertirse en cualquier momento.
`}
				isCollapsed={!expandedGA}
				toggleExpand={() => setExpandedGA(!expandedGA)}
			/>

			<ExpandMore
				title="Renovar firma"
				body={`
								Para el proceso de renovar firma, se requiere el
								codigo de Google o Microsoft Authenticator para
								verificar la identidad del usuario.
`}
				isCollapsed={!expanded3}
				toggleExpand={() => setExpanded3(!expanded3)}
			/>

			<ExpandMore
				title="Revocar firma"
				body={`
								Para el proceso de revocar firma, se requiere el
								codigo de Google o Microsoft Authenticator para
								verificar la identidad del usuario. Una vez
								revocada una firma, esta ya no puede activarse
								de nuevo.
`}
				isCollapsed={!expanded4}
				toggleExpand={() => setExpanded4(!expanded4)}
			/>
		</>
	);
};

export default SignatureRequirements;
